import { render, staticRenderFns } from "./im.vue?vue&type=template&id=4b9ba71e&scoped=true&"
import script from "./im.vue?vue&type=script&lang=ts&"
export * from "./im.vue?vue&type=script&lang=ts&"
import style0 from "./im.vue?vue&type=style&index=0&id=4b9ba71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9ba71e",
  null
  
)

export default component.exports